import classNames from 'classnames';
import { SVGProps } from 'react';

interface AllAssignmentsDoneGraphicProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

function AllAssignmentsDoneGraphic({ className, ...props }: AllAssignmentsDoneGraphicProps) {
  return (
    <svg
      className={classNames(
        'w-[142px] h-[162px]',
        'dk:w-[calc(1.6*142px)] dk:h-[calc(1.6*162px)]', // desktop
        className
      )}
      viewBox='0 0 224 245'
      width={224}
      height={245}
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M110.403 234.732C164.589 234.732 208.728 204.117 210.773 165.84H10.0352C12.0799 204.119 56.2409 234.732 110.405 234.732H110.403Z'
        fill='#3A3A3A'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M4.31916 185.709C6.64501 185.709 8.53822 183.861 8.53822 181.591C8.53822 179.321 6.64777 177.473 4.31916 177.473C1.99055 177.473 0.100098 179.318 0.100098 181.591C0.100098 183.864 1.9933 185.709 4.31916 185.709Z'
        fill='#E5E5EA'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M216.942 157.034C220.777 157.034 223.899 153.916 223.899 150.076C223.899 146.237 220.782 143.119 216.942 143.119C213.102 143.119 209.985 146.242 209.985 150.076C209.985 153.911 213.107 157.034 216.942 157.034Z'
        fill='#3A3A3A'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M64.8818 244.495C68.138 244.495 70.8412 241.792 70.8412 238.532C70.8412 235.271 68.138 232.568 64.8818 232.568C61.6255 232.568 58.9146 235.271 58.9146 238.532C58.9146 241.792 61.6177 244.495 64.8818 244.495Z'
        fill='#625FDB'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M202.228 218.282C204.554 218.282 206.447 216.433 206.447 214.163C206.447 211.893 204.556 210.045 202.228 210.045C199.899 210.045 198.009 211.891 198.009 214.163C198.009 216.436 199.899 218.282 202.228 218.282Z'
        fill='#FFBB53'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M187.619 208.889C169.203 224.662 141.458 234.725 110.409 234.725C79.3595 234.725 51.6145 224.662 33.1978 208.889C21.326 197.297 35.3721 179.697 50.3965 188.336C72.3571 200.969 125.281 231.604 187.622 208.889H187.619Z'
        fill='#595959'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M63.8579 19.8783C66.6397 19.8783 68.8534 17.666 68.8534 14.8855C68.8534 12.105 66.6397 9.93945 63.8579 9.93945C61.076 9.93945 58.9146 12.1518 58.9146 14.8855C58.9146 17.6192 61.1283 19.8783 63.8579 19.8783Z'
        fill='#625FDB'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M213.96 87.4638C217.219 87.4638 219.924 84.8107 219.924 81.4684C219.924 78.126 217.219 75.5371 213.96 75.5371C210.702 75.5371 207.997 78.1901 207.997 81.4684C207.997 84.7466 210.702 87.4638 213.96 87.4638Z'
        fill='#E5E5EA'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M13.1953 91.4384C16.4537 91.4384 19.1586 88.7357 19.1586 85.475C19.1586 82.2143 16.4537 79.5117 13.1953 79.5117C9.93687 79.5117 7.23193 82.2143 7.23193 85.475C7.23193 88.7357 9.93687 91.4384 13.1953 91.4384Z'
        fill='#3A3A3A'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M145.383 13.9144C149.218 13.9144 152.34 10.7965 152.34 6.95722C152.34 3.11795 149.222 0 145.383 0C141.543 0 138.425 3.11795 138.425 6.95722C138.425 10.7965 141.543 13.9144 145.383 13.9144Z'
        fill='#FFBB53'
      />
      <path
        d='M43.7757 162.337C53.6905 174.792 54.9339 190.298 54.9339 190.298C54.9339 190.298 40.9789 184.911 31.0641 172.455C21.1493 160 19.0293 145.192 19.0293 145.192C19.0293 145.192 33.8609 149.881 43.7757 162.337Z'
        fill='#8578C8'
      />
      <path
        d='M50.4482 156.076C55.8681 171.045 52.0967 186.136 52.0967 186.136C52.0967 186.136 40.5915 176.577 35.1716 161.608C29.7516 146.639 32.4694 131.929 32.4694 131.929C32.4694 131.929 45.0282 141.107 50.4482 156.076Z'
        fill='#A092EC'
      />
      <path
        d='M196.007 148.613C189.879 171.154 172.616 186.085 172.616 186.085C172.616 186.085 166.875 164.9 173.003 142.359C179.131 119.818 194.808 104.456 194.808 104.456C194.808 104.456 202.135 126.072 196.007 148.613Z'
        fill='#A092EC'
      />
      <rect
        x='51'
        y='42'
        width='122'
        height='156'
        rx='10'
        fill='#D9D9D9'
        stroke='#606060'
        strokeWidth='6'
      />
      <ellipse cx='114' cy='116.5' rx='38' ry='37.5' fill='#A092EC' />
      <path
        d='M132.167 103.25L107.875 127.542L96.8335 116.5'
        stroke='#1E1E1E'
        strokeWidth='6'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <line
        x1='97'
        y1='168'
        x2='129'
        y2='168'
        stroke='#606060'
        strokeWidth='2'
        strokeLinecap='round'
      />
      <line
        x1='97'
        y1='178'
        x2='129'
        y2='178'
        stroke='#606060'
        strokeWidth='2'
        strokeLinecap='round'
      />
      <rect x='88' y='34' width='52' height='19' rx='3' fill='#5F5F5F' />
    </svg>
  );
}

export default AllAssignmentsDoneGraphic;
